export default __webpack_public_path__ + "static/media/under-maintenance.2660be57.svg";